module.exports = __webpack_public_path__ + "static/img/10.48254d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/10.png
// module id = qzvL
// module chunks = 0